import Markdown from 'react-markdown';
import { useLingui } from '@lingui/react';
import { applyTemplate } from '../util/markdownTemplate';
import classnames from '../util/classnames';

function StatusBarItem({ content = '', className = '', entity }) {
  const { i18n } = useLingui();
  const rendered = applyTemplate(content, { value: entity }, i18n.locale);
  return (
    <div className={classnames(className || undefined, 'p-no-margin')}>
      <Markdown>{rendered}</Markdown>
    </div>
  );
}

function FormStatusBar({ statusBar, entity }) {
  if (!statusBar) return null;

  const { 'ui:classNames': barClassName = '', left = [], middle = [], right = [] } = statusBar;

  if (!left.length && !middle.length && !right.length) return null;

  return (
    <div className={`form-status-bar flex justify-between items-center${barClassName ? ` ${barClassName}` : ''}`}>
      <div className="flex gap-2 items-center">
        {left.map((item, i) => (
          <StatusBarItem key={i} content={item.content} className={item['ui:classNames']} entity={entity} />
        ))}
      </div>
      <div className="flex gap-2 items-center">
        {middle.map((item, i) => (
          <StatusBarItem key={i} content={item.content} className={item['ui:classNames']} entity={entity} />
        ))}
      </div>
      <div className="flex gap-2 items-center">
        {right.map((item, i) => (
          <StatusBarItem key={i} content={item.content} className={item['ui:classNames']} entity={entity} />
        ))}
      </div>
    </div>
  );
}

export default FormStatusBar;
